import { LegalTypeEnum } from '../../../pages/admin/state/legal-entities/legal-entity.model';
import { User } from '../../../pages/admin/state/users/user.model';
import { HashMap, ID } from '@datorama/akita';
import { Badge } from '../../components/sb-badges/sb-badges.component';
import { NewTag } from '../../../features/new-tags/state/tags.model';
import { Currency } from '../../components/currency-selector/currency-country-codes';
import { transformOwnerToLegalEntity } from '../../../pages/admin/state/legal-entities/legal-entity-store.service';
import { AccountIssuer } from '../../../pages/admin/state/account-issuers/account-issuer.model';

export class Acct {
    accountId: number;
    accountVersion: number;
    parentAccountId: number;
    active: boolean;
    //@Size(min = 1, max = 100)
    accountNumber: string;
    //@Size(min = 1, max = 100)
    accountShortName: string;
    //@Size(min = 1, max = 100)
    accountLongName: string;
    //@Size(min = 1, max = 100)
    accountClientAlias: string;
    accountDisplayName: string;
    accountIssuerId: AccountIssuer['accountIssuerId'];
    ownerId: number;
    accountType: AccountTypeEnum;
    correlationId: string;

    // Parameters from decorated account:
    parentAccountNumber: string;
    parentAccountShortName: string;
    parentAccountLongName: string;
    parentAccountClientAlias: string;
    parentAccountDisplayName: string;
    owner: string;
    ownerLegalType: LegalTypeEnum;
    accountIssuerShortName: string;
    accountIssuerLongName: string;
    legalEntity?: ReturnType<typeof transformOwnerToLegalEntity>;

    accountDefinitionVersion: string;
    currency: Currency;
    openingDate: string | Date;
    openingTimestamp: number;
    closingDate: string | Date;
    closingTimestamp: number;
    //Eligible instrument groups
    eligibleForCash: boolean;
    eligibleForSecuritiesAndDerivatives: boolean;
    eligibleForPhysicalAssets: boolean;
    eligibleForLoans: boolean;

    // Do not show in lists if account balance is 0
    hideIfZeroBalance: boolean;

    status?: AccountStatus;
    metadata: any;
    tags?: HashMap<NewTag>;
}

export interface AccountTag extends Badge {
    addedByUserId: User['id'];
    addedTimestamp: Date;
}

export enum AccountStatus {
    ENABLED = 'ENABLED',
    DISABLED = 'DISABLED',
    HIDDEN = 'HIDDEN',
    ALL = '' // used as initial value (ALL)
}

export enum AccountTypeEnum {
    UNKNOWN = 'UNKNOWN',
    ACCOUNT = 'ACCOUNT',
    COLLATERAL = 'COLLATERAL',
    MARGIN = 'MARGIN',
    OTC = 'OTC',
    LOGICAL = 'LOGICAL',
    ALTERNATIVE = 'ALTERNATIVE',
    DEBT = 'DEBT',
    FUTURES = 'FUTURES',
    BROKER = 'BROKER',
    PORTFOLIO = 'PORTFOLIO',
    PRIVATE_ASSET = 'PRIVATE_ASSET',
    CASH = 'CASH',
    CASH_AND_SECURITIES = 'CASH_AND_SECURITIES',
    SECURITIES = 'SECURITIES',
    CASH_ACCOUNT = 'CASH_ACCOUNT',
    SECURITIES_ACCOUNT = 'SECURITIES_ACCOUNT',
    KF = 'KF',
    ISK = 'ISK'
}

export function createAcct(params: Partial<Acct>) {
    return {} as Acct;
}

export function createTag(title: string, addedByUserId: ID) {
    return {
        title,
        addedByUserId,
        addedTimestamp: new Date()
    } as AccountTag;
}
